<template>
  <loader v-if="loadingProducts" />
  <div v-else>
    <h5>
      {{ i18n.t('/pdf/pricelist page/pricelist control codes label') }}
    </h5>

    <div class="products-block">
      <control-codes-products-block :order-service="orderService" :class="rowClass" />

      <app-button
        v-if="products.length > 0"
        :disabled="!isEditable"
        data-qa="show-all-control-codes-button"
        @click="toggleListModal(true)"
      >
        {{ i18n.t('/ProductBlocks/SturingCodes/ShowAllOptions') }}
      </app-button>
    </div>

    <modal
      v-if="showListModal"
      :title="''"
      track-category="service flow"
      @close="toggleListModal(false)"
    >
      <section-content
        v-if="products.length"
        :title="i18n.t('/pdf/pricelist page/pricelist control codes label')"
        :expandable="false"
        :expand-on-load="true"
        :column-name="columnName"
      >
        <ul>
          <product
            v-for="(product, index) in products"
            :key="index"
            :item="product"
            :disabled="product.Forced"
            :is-selected="productIsSelected(product)"
            :show-incl-price="showInclPrice"
            :show-excl-price="showExclPrice"
            @add-to-selected="addToSelected"
            @remove-from-selected="removeFromSelected"
          />
        </ul>
      </section-content>
    </modal>
  </div>
</template>

<script>
import StoreConnector from '@/helpers/StoreConnector'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import Modal from '@/components/generic/presentational/molecules/modal/Modal.vue'
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import Product from '@/components/generic/presentational/molecules/product/Product.vue'
import ControlCodesProductsBlock from '@/components/generic/presentational/organisms/productsBlock/ControlCodesProductsBlock.vue'
import { mapGetters } from 'vuex'
import SectionContent from '@/components/generic/presentational/atoms/sectionContent/SectionContent.vue'

export default {
  components: {
    Loader,
    Modal,
    AppButton,
    Product,
    ControlCodesProductsBlock,
    SectionContent,
  },
  provide() {
    return { showProductDescription: true, titleClickTogglesItem: true }
  },
  props: {
    orderService: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      allSelectedProducts: [],
      products: [],
      selectedProducts: [],
      showListModal: false,
      loadingProducts: true,
    }
  },
  computed: {
    ...mapGetters({
      quoteStatusIsSalesOrder: 'quote/quoteStatusIsSalesOrder',
      showInclPrice: 'quote/isPriceShowIncl',
      showExclPrice: 'quote/isPriceShowExcl',
    }),

    isEditable() {
      return !this.quoteStatusIsSalesOrder
    },
    columnName() {
      return this.showInclPrice ? this.i18n.t(`/common/inclbtw`) : this.i18n.t(`/common/exclbtw`)
    },
    rowClass() {
      if (!this.showInclPrice) return 'row-price-excl'
      if (!this.showExclPrice) return 'row-price-incl'
      return ''
    },
  },
  created() {
    StoreConnector.get('controlCodes/loading', (data) => {
      this.loadingProducts = data
    })

    StoreConnector.get(`${this.orderService.type}/controlCodes`, (data) => {
      this.selectedProducts = data
    })

    StoreConnector.get('controlCodes/all', (data) => {
      this.products = data
    })
  },
  beforeUnmount() {
    StoreConnector.removeListeners([
      'accessories/loading',
      `${this.orderService.type}/controlCodes`,
      'controlCodes/all',
    ])
  },
  methods: {
    toggleListModal() {
      this.showListModal = !this.showListModal
    },
    addToSelected(selectedProduct) {
      this.orderService.addControlCode(selectedProduct)
    },
    productIsSelected(product) {
      return (
        this.selectedProducts.filter((selectedProduct) => selectedProduct.Id === product.Id)
          .length > 0
      )
    },
    removeFromSelected(deselectedProduct) {
      this.orderService.removeControlCode(deselectedProduct)
    },
  },
}
</script>

<style lang="scss" scoped>
:deep() {
  .row {
    grid-template-columns: auto 3em 6em 6em 3em;
    grid-template-areas: 'title code price-excl price-incl buttons';
  }

  .row-price-incl .row {
    grid-template-columns: auto 3em 6em 3em;
    grid-template-areas: 'title code price-incl buttons';
  }

  .row-price-excl .row {
    grid-template-columns: auto 3em 6em 3em;
    grid-template-areas: 'title code price-excl buttons';
  }
}
.products-block {
  margin-bottom: 2em;
}
</style>
